import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["count", "form", "accountIds"];

  clearSelection() {
    // 取消所有复选框
    document
      .querySelectorAll("[data-batch-selection-target='checkbox']")
      .forEach((checkbox) => {
        checkbox.checked = false;
      });

    // 取消全选框
    const selectAll = document.querySelector(
      "[data-batch-selection-target='selectAll']",
    );
    if (selectAll) {
      selectAll.checked = false;
      selectAll.indeterminate = false;
    }

    // 隐藏批量操作栏
    this.element.style.display = "none";
  }
}
